import { RepoListener } from "../repo/repoListener";

export const sendMessage = async (msgId, payload, tab) => {
  //transform request to what repo is looking for:
  const request = {
    msgId,
    payload: payload,
  };

  const sender = {
    tab: tab,
  };

  const myPromise = new Promise((resolve) => {
    const sendResponse = async (res) => {
      resolve(res);
    };

    RepoListener(request, sender, sendResponse);
  });

  return myPromise;
};

